import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f794facc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "profile_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "profile_title_text" }, "基本情報の編集")
], -1))
const _hoisted_3 = { class: "profile_input" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "氏名"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_5 = { class: "profile_input_layout_column_2" }
const _hoisted_6 = { class: "profile_input_layout_column_2_item" }
const _hoisted_7 = { class: "profile_input_layout_column_2_item" }
const _hoisted_8 = { class: "profile_input" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "フリガナ"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_10 = { class: "profile_input_layout_column_2" }
const _hoisted_11 = { class: "profile_input_layout_column_2_item" }
const _hoisted_12 = { class: "profile_input_layout_column_2_item" }
const _hoisted_13 = { class: "profile_input" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "性別"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_15 = { class: "profile_input_layout_column_2" }
const _hoisted_16 = { class: "profile_input" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "生年月日"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_18 = { class: "profile_input_item_dateofbirth" }
const _hoisted_19 = { class: "profile_input" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "携帯電話番号"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_21 = { class: "profile_input_layout_column_1" }
const _hoisted_22 = { class: "profile_input_layout_column_1_item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profile_text" }, "※半角数字のみ、ハイフンなしでご入力ください", -1))
const _hoisted_24 = { class: "profile_input" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "郵便番号と住所"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_26 = {
  key: 0,
  class: "profile_input_postcode"
}
const _hoisted_27 = { class: "profile_input_pref" }
const _hoisted_28 = { class: "profile_input_layout_column_2" }
const _hoisted_29 = { class: "profile_input_layout_column_2_item" }
const _hoisted_30 = { class: "profile_input_layout_column_2_item" }
const _hoisted_31 = { class: "profile_input_layout_column_1" }
const _hoisted_32 = { class: "profile_input_layout_column_1_item" }
const _hoisted_33 = { class: "profile_input_layout_column_1_item" }
const _hoisted_34 = { class: "profile_button" }
const _hoisted_35 = { class: "profile_button_prev" }
const _hoisted_36 = { class: "profile_button_next" }

import { ref, Ref, computed, onMounted, watchEffect } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useField, useForm } from 'vee-validate';
import { getMasterDataListPref, getMasterDataListSex, MasterDataSex } from '@/api/masterDataEndpoint';
import alertOnReload from '@/utils/alertOnReload';
import store from '@/store';
import BaseTextForm from '@/components/BaseTextForm.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseRadioButton from '@/components/BaseRadioButton.vue';
import BaseYmdForm from '@/components/BaseYmdForm.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import BaseSelectBox, { Options } from '@/components/BaseSelectBox.vue';
import PostCodeForm from '@/components/PostCodeForm.vue';
import { validationRuleHelper } from '@/utils/validationRule';
import { RadioListType } from '@/types';
import SelectRadioModal from '@/components/SelectRadioModal.vue';
import * as AutoKana from 'vanilla-autokana';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileEditView',
  setup(__props) {

const isLoading = ref(false);
const { meta, errors } = useForm();

const { value: lastName, errors: lastNameErrors } = useField<string>('lastName', validationRuleHelper({ required: true }), {
  initialValue: '',
  bails: false,
  label: '姓',
});
const { value: firstName, errors: firstNameErrors } = useField<string>('firstName', validationRuleHelper({ required: true }), {
  initialValue: '',
  bails: false,
  label: '名',
});
const { value: lastNameKana, errors: lastNameKanaErrors } = useField<string>(
  'lastNameKana',
  validationRuleHelper({ required: true, zen_kana: true }),
  {
    initialValue: '',
    bails: false,
    label: 'セイ',
  }
);
const { value: firstNameKana, errors: firstNameKanaErrors } = useField<string>(
  'firstNameKana',
  validationRuleHelper({ required: true, zen_kana: true }),
  {
    initialValue: '',
    bails: false,
    label: 'メイ',
  }
);
let lastNameAutokana: any;
let firstNameAutokana: any;
onMounted(() => {
  lastNameAutokana = AutoKana.bind('#lastName', "#lastNameKana", { katakana: true });
  firstNameAutokana = AutoKana.bind('#firstName', "#firstNameKana", { katakana: true });
});

// 入力時にふりがなを更新
const lastNameInput = () => {
  lastNameKana.value = lastNameAutokana.getFurigana();
};

const firstNameInput = () => {
  firstNameKana.value = firstNameAutokana.getFurigana();
};

const sexList: Ref<MasterDataSex[]> = ref([]);
const { value: sexFlg, errors: sexFlgErrors } = useField<number | null>('sexFlg', validationRuleHelper({ required: true }), {
  initialValue: null,
  bails: false,
  label: '性別',
});
const { value: birthDate, errors: birthDateErrors } = useField<string>('birthDate', validationRuleHelper({ required: true }), {
  initialValue: '',
  bails: false,
  label: '生年月日',
});
const { value: telCellular, errors: telCellularErrors } = useField<string>(
  'telCellular',
  validationRuleHelper({ required: true, numeric: true }),
  {
    initialValue: '',
    bails: false,
    label: '携帯電話番号',
  }
);
const { value: zipCode, errors: zipCodeErrors } = useField<string>(
  'zipCode',
  validationRuleHelper({ required: true, zipcode_length: true, numeric: true }),
  {
    initialValue: '',
    bails: false,
    label: '郵便番号',
  }
);
const prefOptions: Ref<Options> = ref([]);
const { value: prefId, errors: prefIdErrors } = useField<string>('prefId', validationRuleHelper({ required: true }), {
  initialValue: '',
  bails: false,
  label: '都道府県',
});
const { value: addr1, errors: addr1Errors } = useField<string>('addr1', validationRuleHelper({ required: true }), {
  initialValue: '',
  bails: false,
  label: '市区郡町村',
});
const { value: addr2, errors: addr2Errors } = useField<string>('addr2', validationRuleHelper({ required: true }), {
  initialValue: '',
  bails: false,
  label: '町名・丁目・番地・号',
});
const { value: addr3 } = useField<string>('addr3', undefined, {
  initialValue: '',
  bails: false,
  label: '建物・マンション名',
});

const init = async () => {
  isLoading.value = true;
  try {
    const [mstSexList, mstPrefList] = await Promise.all([getMasterDataListSex(), getMasterDataListPref()]);
    sexList.value = mstSexList;
    prefOptions.value = mstPrefList.map((i) => {
      return { value: i.code, label: i.name };
    });

    firstName.value = store.getters['userRegistration/firstName'];
    lastName.value = store.getters['userRegistration/lastName'];
    firstNameKana.value = store.getters['userRegistration/firstNameKana'];
    lastNameKana.value = store.getters['userRegistration/lastNameKana'];
    sexFlg.value = store.getters['userRegistration/sexFlg'];
    birthDate.value = store.getters['userRegistration/birthDate'];
    telCellular.value = store.getters['userRegistration/telCellular'];
    zipCode.value = store.getters['userRegistration/zipCode'];
    prefId.value = store.getters['userRegistration/prefId'];
    addr1.value = store.getters['userRegistration/addr1'];
    addr2.value = store.getters['userRegistration/addr2'];
    addr3.value = store.getters['userRegistration/addr3'];
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};
init();

const searchAddress = async (postCode: string) => {
  // 入力された郵便番号より住所情報を取得
  await Promise.all([
      store.dispatch('master/getMasterDataPostCode', { postCode }),
  ]);
  const postCodeList = store.getters['master/postCodeList'];

  if (postCodeList.length === 1) {
    prefId.value = String(postCodeList[0].prefId);
    addr1.value = postCodeList[0].cityName;
    addr2.value = postCodeList[0].blockName;
  } else if (postCodeList.length > 1) {
    openPostCodeModal();
  } else {
    console.error('not found');
    return;
  }
};

const nameErrors = computed(() => {
  return [firstNameErrors.value, lastNameErrors.value].flat();
});

const nameKanaErrors = computed(() => {
  return [firstNameKanaErrors.value, lastNameKanaErrors.value].flat();
});

const addrErrors = computed(() => {
  return [prefIdErrors.value, addr1Errors.value, addr2Errors.value].flat();
});

const router = useRouter();
const route = useRoute();

const transitionPage = () => {
  store.commit('userRegistration/setFirstName', firstName.value);
  store.commit('userRegistration/setLastName', lastName.value);
  store.commit('userRegistration/setFirstNameKana', firstNameKana.value);
  store.commit('userRegistration/setLastNameKana', lastNameKana.value);
  store.commit('userRegistration/setSexFlg', sexFlg.value);
  store.commit('userRegistration/setSex', sexList.value.filter((i) => i.code === sexFlg.value)[0]?.name || '');
  store.commit('userRegistration/setBirthDate', birthDate.value);
  store.commit('userRegistration/setTelCellular', telCellular.value);
  store.commit('userRegistration/setZipCode', zipCode.value);
  store.commit('userRegistration/setPrefId', prefId.value);
  store.commit('userRegistration/setPref', prefOptions.value.filter((i) => String(i.value) === prefId.value)[0]?.label || '');
  store.commit('userRegistration/setAddr1', addr1.value);
  store.commit('userRegistration/setAddr2', addr2.value);
  store.commit('userRegistration/setAddr3', addr3.value);

  if (route.query.ref === 'e') {
    router.push({ name: 'e22', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e22' });
  }
};

const transitionPreviousPage = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e20', query: { ref: 'e' } });
  } else {
    router.push({ name: 'n20' });
  }
};
alertOnReload();

const zipId = ref();
const postCodeFlat: Ref<{ [key: number]: string }> = computed(() => {
  return store.getters['master/postCode'];
});
const postCodeList: Ref<RadioListType[]> = computed(() => {
  return store.getters['master/postCodeRadioList'];
});

// 住所情報の更新
watchEffect(() => {
  if (zipId.value !== undefined) {
    const postCode = postCodeFlat.value[zipId.value];
    prefId.value = zipId.value === null ? '' : postCode.get('prefId') || '';
    addr1.value = zipId.value === null ? '' : postCode.get('cityName') || '';
    addr2.value = zipId.value === null ? '' : postCode.get('blockName') || '';
  };
});

const shownPostCodeModal = ref(false);
const openPostCodeModal = () => {
  shownPostCodeModal.value = true;
};
const closePostCodeModal = () => {
  shownPostCodeModal.value = false;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(BaseTextForm, {
              name: "lastName",
              id: "lastName",
              placeholder: "姓",
              maxlength: 50,
              modelValue: _unref(lastName),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(lastName) ? (lastName).value = $event : null)),
              isError: _unref(lastNameErrors).length > 0,
              onInput: lastNameInput
            }, null, 8, ["modelValue", "isError"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(BaseTextForm, {
              name: "firstName",
              id: "firstName",
              placeholder: "名",
              maxlength: 50,
              modelValue: _unref(firstName),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(firstName) ? (firstName).value = $event : null)),
              isError: _unref(firstNameErrors).length > 0,
              onInput: firstNameInput
            }, null, 8, ["modelValue", "isError"])
          ])
        ])
      ]),
      _createVNode(ErrorMessage, { errors: _unref(nameErrors) }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(BaseTextForm, {
              name: "lastNameKana",
              id: "lastNameKana",
              placeholder: "セイ",
              maxlength: 50,
              modelValue: _unref(lastNameKana),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(lastNameKana) ? (lastNameKana).value = $event : null)),
              isError: _unref(lastNameKanaErrors).length > 0
            }, null, 8, ["modelValue", "isError"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(BaseTextForm, {
              name: "firstNameKana",
              id: "firstNameKana",
              placeholder: "メイ",
              maxlength: 50,
              modelValue: _unref(firstNameKana),
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(firstNameKana) ? (firstNameKana).value = $event : null)),
              isError: _unref(firstNameKanaErrors).length > 0
            }, null, 8, ["modelValue", "isError"])
          ])
        ])
      ]),
      _createVNode(ErrorMessage, { errors: _unref(nameKanaErrors) }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sexList.value, (sexItem) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "profile_input_layout_column_2_item",
              key: sexItem.code
            }, [
              _createVNode(BaseRadioButton, {
                label: sexItem.name,
                name: "sex",
                value: sexItem.code,
                modelValue: _unref(sexFlg),
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(sexFlg) ? (sexFlg).value = $event : null)),
                modelModifiers: { number: true }
              }, null, 8, ["label", "value", "modelValue"])
            ]))
          }), 128))
        ])
      ]),
      _createVNode(ErrorMessage, { errors: _unref(sexFlgErrors) }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createVNode(BaseYmdForm, {
            modelValue: _unref(birthDate),
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(birthDate) ? (birthDate).value = $event : null)),
            placeholder: "2000-01-01",
            yearSort: "desc"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createVNode(ErrorMessage, { errors: _unref(birthDateErrors) }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(BaseTextForm, {
              modelValue: _unref(telCellular),
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(telCellular) ? (telCellular).value = $event : null)),
              type: "tel",
              maxlength: 20,
              placeholder: "09012345678",
              isError: !!_unref(errors).telCellular
            }, null, 8, ["modelValue", "isError"]),
            _createVNode(ErrorMessage, { errors: _unref(telCellularErrors) }, null, 8, ["errors"]),
            _hoisted_23
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        (!isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createVNode(PostCodeForm, {
                modelValue: _unref(zipCode),
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(zipCode) ? (zipCode).value = $event : null)),
                onClick: searchAddress,
                isError: !!_unref(errors).zipCode
              }, null, 8, ["modelValue", "isError"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(ErrorMessage, { errors: _unref(zipCodeErrors) }, null, 8, ["errors"]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createVNode(BaseSelectBox, {
                placeholder: "都道府県を選択",
                options: prefOptions.value,
                modelValue: _unref(prefId),
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(prefId) ? (prefId).value = $event : null))
              }, null, 8, ["options", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(BaseTextForm, {
                modelValue: _unref(addr1),
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(addr1) ? (addr1).value = $event : null)),
                maxlength: 50,
                placeholder: "市区郡町村",
                isError: !!_unref(errors).addr1
              }, null, 8, ["modelValue", "isError"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createVNode(BaseTextForm, {
              modelValue: _unref(addr2),
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(addr2) ? (addr2).value = $event : null)),
              maxlength: 70,
              placeholder: "町名・丁目・番地・号",
              isError: !!_unref(errors).addr2
            }, null, 8, ["modelValue", "isError"])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(BaseTextForm, {
              modelValue: _unref(addr3),
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(addr3) ? (addr3).value = $event : null)),
              maxlength: 70,
              placeholder: "建物・マンション名",
              isError: !!_unref(errors).addr3
            }, null, 8, ["modelValue", "isError"])
          ])
        ])
      ]),
      _createVNode(ErrorMessage, { errors: _unref(addrErrors) }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createVNode(BaseButton, {
            onClick: transitionPreviousPage,
            theme: "tertiary",
            type: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("戻る")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createVNode(BaseButton, {
            onClick: transitionPage,
            theme: "primary",
            type: "button",
            disabled: !_unref(meta).valid
          }, {
            default: _withCtx(() => [
              _createTextVNode("確認する")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]),
    (shownPostCodeModal.value)
      ? (_openBlock(), _createBlock(SelectRadioModal, {
          key: 0,
          title: "住所選択",
          modelValue: zipId.value,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((zipId).value = $event)),
          list: _unref(postCodeList),
          onClose: closePostCodeModal
        }, null, 8, ["modelValue", "list"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})